import React from 'react';
import { logoAvatarStyles } from './styles';
import { Logo } from '../Logo';
import { Avatar } from '../Avatar';

/*

Props:
• imageURL
• logoURL
• size
• style

*/
const _applyStyleModifiers = (props) => {
    const { imageURL, logoURL, size } = props;
    const { avatarLogoStyle } = logoAvatarStyles; 

    if (size) {
        avatarLogoStyle.height = avatarLogoStyle.width = size / 3;
        
        avatarLogoStyle.top = size - (avatarLogoStyle.height / 1.2);
    }

    return {avatarLogoStyle};
}

export const LogoAvatar = (props) => {
    
    const styles = _applyStyleModifiers(props);

    return (
        <Avatar imageURL={props.imageURL} size={props.size} style={{...props.style}}>
            { props.logoURL && <Logo style={{ top: styles.avatarLogoStyle.top }} logoURL={props.logoURL} size={styles.avatarLogoStyle.height} />}
        </Avatar>
    );
};


// WEBPACK FOOTER //
// ./src/js/components/LogoAvatar/LogoAvatar.jsx